export default __webpack_public_path__ + "static/media/bookmark_filled.efc62643.svg";